import { render } from "./RestorantsNearMe.vue?vue&type=template&id=4a8ee46f&ts=true"
import script from "./RestorantsNearMe.vue?vue&type=script&lang=ts"
export * from "./RestorantsNearMe.vue?vue&type=script&lang=ts"

import "./RestorantsNearMe.vue?vue&type=style&index=0&id=4a8ee46f&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__